import { StepShell } from "./ui";
import type { AfiliacionForm } from "./types";

interface StepEnviarProps {
  form: AfiliacionForm;
  accepted: boolean;
  onAcceptedChange: (value: boolean) => void;
}

export default function StepEnviar({ form, accepted, onAcceptedChange }: StepEnviarProps) {
  const totalDocs =
    form.documentosGenerales.length +
    form.vehiculos.reduce((acc, veh) => acc + veh.documentos.length, 0);

  const stats = [
    { label: "Vehículos", value: form.vehiculos.length, icon: "ri-truck-line" },
    { label: "Servicios", value: form.servicios.length, icon: "ri-service-line" },
    { label: "Documentos", value: totalDocs, icon: "ri-folder-line" },
  ];

  return (
    <StepShell
      title="Enviar solicitud"
      description="Todo listo. Al enviar, tu solicitud quedará registrada y nuestro equipo la revisará. Esto no implica una contratación automática."
    >
      <div className="space-y-5">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3.5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className={`${stat.icon} text-lg leading-none`} aria-hidden="true"></i>
              </span>
              <div>
                <p className="text-xl font-heading font-bold text-foreground-950">{stat.value}</p>
                <p className="text-xs font-label uppercase tracking-wide text-foreground-500">
                  {stat.label}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="rounded-lg border border-accent-300 bg-accent-50 p-5">
          <h3 className="flex items-center gap-2 text-sm font-heading font-semibold text-accent-900">
            <i className="ri-information-line text-base leading-none" aria-hidden="true"></i>
            Importante
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-accent-900">
            Esta es una <strong>solicitud para formar parte de la red de colaboradores</strong> de
            AXONIA GROUP. La aceptación queda bajo revisión administrativa y no garantiza trabajos,
            ingresos ni una cantidad determinada de servicios.
          </p>
        </div>

        <label
          htmlFor="acepta"
          className="flex cursor-pointer items-start gap-3 rounded-lg border border-background-300 bg-background-50 p-4"
        >
          <input
            id="acepta"
            type="checkbox"
            checked={accepted}
            onChange={(event) => onAcceptedChange(event.target.checked)}
            className="mt-0.5 h-4 w-4 shrink-0 rounded border-background-400 text-primary-600 focus:ring-primary-400"
          />
          <span className="text-sm leading-relaxed text-foreground-700">
            Confirmo que la información proporcionada es verídica y autorizo a AXONIA GROUP a
            contactarme para continuar con el proceso de revisión.
          </span>
        </label>
      </div>
    </StepShell>
  );
}